import { createCombinedStateHook } from '../utils/createCombinedStateHook'

export const {
  useCombinedStateRoot: useBusyContext,
  useSetChildState: useIsBusy,
} = createCombinedStateHook(isAppBusy)

function isAppBusy(busyElements: Record<string, boolean>) {
  return Object.values(busyElements).some((busy) => busy === true)
}
